import { Link } from '@client/router/compat';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowRight,
  faArrowUpRightFromSquare,
  faXmark,
} from '@fortawesome/pro-regular-svg-icons';
import { faWandMagicSparkles } from '@fortawesome/pro-solid-svg-icons';
import { useLocalStorage } from '@client/hooks/use-local-storage';
import * as styles from './LandingPagePreviewBanner.css';

type LandingPagePreviewBannerProps = {
  visible: boolean;
  previewUrl: string;
  switchTo: string;
  dismissKey: string;
};

export const LandingPagePreviewBanner = ({
  visible,
  previewUrl,
  switchTo,
  dismissKey,
}: LandingPagePreviewBannerProps) => {
  const [dismissed, setDismissed] = useLocalStorage(dismissKey, false);

  if (!visible || dismissed) return null;

  return (
    <section className={styles.banner} aria-label="New landing page look">
      <div className={styles.iconTile}>
        <FontAwesomeIcon icon={faWandMagicSparkles} />
      </div>
      <div className={styles.body}>
        <div className={styles.titleLine}>
          <span className={styles.newPill}>New</span>
          <p className={styles.title}>Your new landing page is ready</p>
        </div>
        <p className={styles.text}>
          Preview it with your own content, then switch when you&apos;re ready.
          All your pages update together.
        </p>
      </div>
      <div className={styles.actions}>
        <a
          href={previewUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.cta}
        >
          Open preview
          <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
        </a>
        <Link to={switchTo} className={styles.secondaryCta}>
          Switch now
          <FontAwesomeIcon icon={faArrowRight} />
        </Link>
      </div>
      <button
        type="button"
        aria-label="Dismiss"
        className={styles.dismiss}
        onClick={() => setDismissed(true)}
      >
        <FontAwesomeIcon icon={faXmark} />
      </button>
    </section>
  );
};
